import React from 'react'
import { UserAccountInfoProps } from './types'

const UserAccountInfo: React.FC<UserAccountInfoProps> = ({
  user,
  isEditingName,
  editedName,
  setEditedName,
  onUpdateName,
  onCancelEdit,
  onStartEdit,
  onShowSuccessToast,
  onShowErrorToast,
}) => {
  const handleSave = async () => {
    const result = await onUpdateName()
    if (result.success) {
      onShowSuccessToast()
    } else {
      onShowErrorToast()
    }
  }

  return (
    <div className="card bg-base-200 shadow-xl mb-8">
      <div className="card-body">
        <h2 className="card-title mb-4">Account Information</h2>
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium">Name</label>
            <div className="flex items-center gap-2">
              {isEditingName ? (
                <>
                  <input
                    type="text"
                    className="input input-bordered w-full max-w-xs"
                    value={editedName}
                    onChange={(e) => setEditedName(e.target.value)}
                    placeholder="Enter your name"
                    autoFocus
                  />
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    className="btn btn-ghost btn-sm"
                    onClick={onCancelEdit}
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <>
                  <p className="text-lg">
                    {user.user_metadata?.full_name || 'No name set'}
                  </p>
                  <button
                    className="btn btn-ghost btn-sm"
                    onClick={onStartEdit}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                    </svg>
                    Edit
                  </button>
                </>
              )}
            </div>
          </div>
          <div>
            <label className="text-sm font-medium">Email</label>
            <p className="text-lg">{user.email}</p>
          </div>
          <div>
            <label className="text-sm font-medium">Member Since</label>
            <p className="text-lg">
              {new Date(user.created_at).toLocaleDateString()}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserAccountInfo
